export default __webpack_public_path__ + "images/pointer-blue.b98f1325b6362e4a1c64469dbaa847ef.png";